export default {
  LOADING: 'MARKETS_VIEW_SETTLEMENT_TABLE_LOADING',
  LOADED: 'MARKETS_VIEW_SETTLEMENT_TABLE_LOADED',
  SELECT_CONTRACT_ROW: 'MARKETS_VIEW_SETTLEMENT_TABLE_ROW_SELECTED',
  SELECT_TOTAL_ROW: 'MARKETS_VIEW_SETTLEMENT_TABLE_TOTAL_ROW_SELECTED',
  DESELECT_ROW: 'MARKETS_VIEW_SETTLEMENT_TABLE_ROW_DESELECTED',
};
